import { createSlice } from "@reduxjs/toolkit";

// initial state
const initialState = null;

// ==============================|| SLICE - ACCOUNT ||============================== //

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setAccounts(state, action) {
      return action.payload;
    },
    addAccount(state, action) {
      if (state === null) {
        return [action.payload];
      }
      return [...state, action.payload];
    },
    updateAccount(state, action) {
      if (state === null) return state;
      return state.map((account) =>
        account._id === action.payload._id ? action.payload : account
      );
    },
    deleteAccount(state, action) {
      if (state === null) return state;
      return state.filter((account) => account._id !== action.payload);
    },
  },
});

export default accountSlice.reducer;

export const {
  setAccounts,
  addAccount,
  updateAccount,
  deleteAccount,
} = accountSlice.actions;

// Legacy action type constants for backward compatibility during migration
export const ACCOUNT_ACTION_TYPES = {
  SET_ACCOUNTS: "account/setAccounts",
  ADD_ACCOUNT: "account/addAccount",
  UPDATE_ACCOUNT: "account/updateAccount",
  DELETE_ACCOUNT: "account/deleteAccount",
};
